import React from 'react';
import { Grid } from '@mui/material';
import SearchFilter from '../../../components/filters/SearchFilter';
import DateRangeFilter from '../../../components/filters/DateRangeFilters';

const BulkUploadListFilters = ({
  filters,
  selectedFilter,
  onFilterChange,
  searchTerm,
  onSearchChange,
  onSearchKeyPress,
  onDateRangeChange,
}) => {
  const renderFilter = (filter) => {
    switch (filter.type) {
      case 'search':
        return (
          <SearchFilter
            key={filter.type}
            filter={filter}
            selectedFilter={selectedFilter}
            onFilterChange={onFilterChange}
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
            onSearchKeyPress={onSearchKeyPress}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Grid item xs={12} sx={{ padding: '2px' }} container justifyContent="space-between" alignItems="center" spacing={1}>
      <Grid item xs={12} sx={{ mb: 2 }}>
        <DateRangeFilter onChange={onDateRangeChange} />
      </Grid>
      <Grid item container spacing={1} justifyContent="flex-end">
        {filters.map((filter) => renderFilter(filter))}
      </Grid>
    </Grid>
  );
};

export default BulkUploadListFilters;
